/**
 * Karta för hotell- och kampanjsidan (template-parts/single-hotel-map.php).
 * Kopplar kartans egna kontroller (karta/satellit, fullskärm, zoom) och
 * placerar hotellets markör.
 */
window.svmInitHotelMap = function(options) {
    'use strict';

    const container = document.querySelector('#map');
    if (!container || typeof mapboxgl === 'undefined') {
        return null;
    }

    const wrapper = container.closest('[data-hotel-map]') || container.parentElement;

    const styles = {
        map: 'mapbox://styles/mapbox/streets-v12',
        satellite: 'mapbox://styles/mapbox/satellite-streets-v12',
    };

    const map = new mapboxgl.Map({
        container: container,
        style: styles.map,
        center: options.center,
        zoom: 14,
        cooperativeGestures: options.cooperativeGestures ?? true,
    });

    // DOM-markör ligger kvar när kartstilen byts, till skillnad från ett symbol-lager
    const marker = document.createElement('img');
    marker.src = options.isPromoted
        ? '/wp-content/themes/svenskamoten.se/static/images/map-icon-2x.png'
        : '/wp-content/themes/svenskamoten.se/static/images/map-icon-non-member-2x.png';
    marker.alt = '';
    marker.className = 'w-12 h-auto';
    new mapboxgl.Marker({ element: marker, anchor: 'bottom' }).setLngLat(options.center).addTo(map);

    wrapper.querySelectorAll('[data-map-style]').forEach(function(button) {
        button.addEventListener('click', function() {
            const style = button.getAttribute('data-map-style');
            map.setStyle(styles[style]);

            wrapper.querySelectorAll('[data-map-style]').forEach(function(other) {
                const active = other === button;
                other.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
        });
    });

    const zoomIn = wrapper.querySelector('[data-map-zoom-in]');
    const zoomOut = wrapper.querySelector('[data-map-zoom-out]');
    const fullscreen = wrapper.querySelector('[data-map-fullscreen]');

    zoomIn && zoomIn.addEventListener('click', function() {
        map.zoomIn();
    });

    zoomOut && zoomOut.addEventListener('click', function() {
        map.zoomOut();
    });

    fullscreen && fullscreen.addEventListener('click', function() {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else if (wrapper.requestFullscreen) {
            wrapper.requestFullscreen();
        }
    });

    document.addEventListener('fullscreenchange', function() {
        const active = document.fullscreenElement === wrapper;
        wrapper.classList.toggle('is-fullscreen', active);
        fullscreen && fullscreen.setAttribute('aria-pressed', active ? 'true' : 'false');
        map.resize();
    });

    return map;
};
